export default __webpack_public_path__ + "static/google-review-d8f69c72017435d2716d8f237086757f.png";